import type { ResolveActiveNodes } from "../../nodes/index.ts";
import type { AvailableValue } from "../../types/index.ts";
import type { GetNodeValues } from "./getNodeValues.ts";

interface CreateOptions {
  resolveActiveNodes: ResolveActiveNodes;
  getNodeValues: GetNodeValues;
}

/** All values advertised by the nodes active for a context node. */
// TODO: this is just returning values for active nodes given a node
// but this will not always work at runtime as we would need to ensure render order
// was according to binding dependencies and ensure no loops. non-trivial.
// maybe we could do multi pass, where we track binding deps and re-render affected nodes
// until there are none left to re-render
export const resolveAvailableValuesCreate =
  ({ resolveActiveNodes, getNodeValues }: CreateOptions) =>
  (contextNodeId: number): AvailableValue[] =>
    resolveActiveNodes(contextNodeId).flatMap((node) =>
      getNodeValues(node).map((descriptor) => ({ ...descriptor, nodeId: node.id, nodeRole: node.role })),
    );

export type ResolveAvailableValues = ReturnType<typeof resolveAvailableValuesCreate>;

/**
 * Whether a value resolves on at least one level (design-time or runtime).
 * All consumers offer the same two levels — there is no per-consumer plane.
 */
export const valueIsResolvable = (value: Pick<AvailableValue, "designTime" | "runtimePath">): boolean =>
  !!value.designTime || !!value.runtimePath;
